import React from "react";

import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import "@fullcalendar/react"; // preload @fullcalendar/react

import useSceneLastViewMode from "../../util/hook/useSceneLastViewMode";

import ActivityCalendarPage from "./component/ActivityCalendarPage";
import ActivityListPage from "./component/ActivityListPage";
import ActivitySchedulerPage from "./component/ActivitySchedulerPage";
import ViewMode from "./enum/ViewMode";
import FilePage from "./FilePage";

interface Props {}

const ActivityPage: React.FC<Props> = () => {
  const { path } = useRouteMatch();
  const lastViewMode = useSceneLastViewMode(path, ViewMode, ViewMode.CALENDAR);

  return (
    <Switch>
      <Route exact path={`${path}/:aid/files/:fileId`} component={FilePage} />
      <Route path={`${path}/${ViewMode.CALENDAR}`} component={ActivityCalendarPage} />
      <Route path={`${path}/${ViewMode.LIST}`} component={ActivityListPage} />
      <Route path={`${path}/${ViewMode.SCHEDULER}`} component={ActivitySchedulerPage} />
      <Route exact path={path}>
        <Redirect to={`${path}/${lastViewMode}`} />
      </Route>
    </Switch>
  );
};

export default ActivityPage;
